import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';
import Dialog from '@material-ui/core/Dialog';

export interface ConfirmProps {
    title?: string;
    message?: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    okLabel?: string;
    cancelLabel?: string;
}

const styles = {
    modal: {
        width: 600,
    },
    content: {
        padding: '20px',
    },
};

export const Confirm: React.FC<ConfirmProps> = ({
    title = 'Confirm Action',
    message = 'message text not specified',
    okLabel = 'OK',
    cancelLabel = 'Cancel',
    onCancel,
    onConfirm,
}) => {
    const handleConfirm = useCallback(() => {
        onConfirm && onConfirm();
        removeModal();
    }, [onConfirm]);

    const handleCancel = useCallback(() => {
        onCancel && onCancel();
        removeModal();
    }, [onCancel]);

    return (
        <Dialog
            maxWidth='lg'
            open={true}
            onClose={handleCancel}
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex={-1}
                    role='dialog'
                    style={styles.modal}
                >
                    <div
                        className='page-header'
                        role='banner'
                    >
                        <h1>{title}</h1>
                        <button
                            type='button'
                            className='close'
                            data-dismiss='modal'
                            aria-label='Close'
                            onClick={handleCancel}
                        >
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                    <div
                        className='modal-dialog'
                        role='document'
                        style={styles.content}
                    >
                        {message}
                    </div>
                    <div className='button-group'>
                        <button
                            onClick={handleConfirm}
                            className='button'
                            aria-label='OK'
                        >
                            {okLabel}
                        </button>
                        <button
                            onClick={handleCancel}
                            className='button'
                            aria-label='Cancel'
                        >
                            {cancelLabel}
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

const mountPointId = 'bfi-apply-confirm-modal';

// the ignore below are because really the branch being ignored is providing
// arguably over-zealous protection against throwing null-ref exceptions when something
// in the browser has just gone horribly wrong, but really can't be tested
export const removeModal = (): void => {
    const mountPoint = document.getElementById(mountPointId);
    /* istanbul ignore else */
    if (mountPoint) {
        ReactDOM.unmountComponentAtNode(mountPoint);
        mountPoint.parentNode.removeChild(mountPoint);
    }
};

export const confirmModal = (props: ConfirmProps): void => {
    let mountPoint = document.getElementById(mountPointId);
    if (mountPoint) {
        ReactDOM.render(<Confirm {...props} />, mountPoint);
    } else {
        mountPoint = document.createElement('div');
        mountPoint.id = mountPointId;
        document.body.appendChild(mountPoint);
        ReactDOM.render(<Confirm {...props} />, mountPoint);
    }
};
